import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e2c7e188&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "styles/components/payDialog.css?vue&type=style&index=0&id=e2c7e188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c7e188",
  null
  
)

export default component.exports